































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Tooltip from '@/common/components/Tooltip.vue'
import { countRemainingTimeForShipping, formatSliceYear, formatOneDecimal } from '@/common/utils/common'
import { gaEventTracker, EVENT_LABELS, EVENT_ACTIONS, EVENT_CATEGORIES } from '@/common/utils'
import DeliveryDateCtrl from '@/product/components/DeliveryDateCtrl.vue'
export default Vue.extend({
  components: {
    Tooltip,
    DeliveryDateCtrl
  },
  props: {
    gifteeProduct: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    calcTimeInterval: number | null,
    timeLeft: string
  } {
    return {
      calcTimeInterval: null,
      timeLeft: ''
    }
  },
  computed: {
    ...mapGetters([
      'estimate'
    ]),
    deliveryLabel(): string {
      return this.gifteeProduct ? '銀行振込' : 'コンビニ支払い / 銀行振込'
    }
  },
  created() {
    this.calcTimeInterval = window.setInterval(() => {
      this.timeLeft = countRemainingTimeForShipping()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.calcTimeInterval!)
  },
  methods:{
    formatOneDecimal,
    formatSliceYear,
    openModal() {
      this.$emit('onOpen')
      this.eventTracker()
    },
    eventTracker(){
      const isMobile = window.innerWidth < 1024
      const payload = {
        category: EVENT_CATEGORIES.PRODUCT_DETAIL,
        action: EVENT_ACTIONS.OPEN,
        label:isMobile ? EVENT_LABELS.MOBILE_DELIVERY_DATECHECK_DIALOG : EVENT_LABELS.PC_DELIVERY_DATECHECK_DIALOG
      }
      gaEventTracker(payload)
    }
  }
})
